import { IHospitalStore } from './types';

const initStore: IHospitalStore = {
  selectors: null,
  counters: null,
  events: [],
  details: null,
  pagination: {
    page: 0,
    itemsPerPage: 20,
    hasMore: false,
  },
};

export default initStore;
